import { Component, ViewChildren, QueryList, ElementRef, AfterViewChecked, ChangeDetectorRef, ViewChild } from "@angular/core";
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Data } from "@angular/router";
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { taxFormModel } from '../models/taxFormModel'
import { CertificationService } from '../services/certification.service'
import { AppSettings } from '../../shared/configuration/appsettings.config';
import { Validator } from "../../shared/component/validator.component";
import { attachment } from "../models/attachment";
import { PageService, SortService, FilterService, GroupService, GridComponent } from '@syncfusion/ej2-angular-grids'
import { PageSettingsModel } from '@syncfusion/ej2-angular-grids';
import { FileInfo, MaskedTextBoxComponent, UploaderComponent } from '@syncfusion/ej2-angular-inputs'
import { CheckBoxSelectionService } from '@syncfusion/ej2-angular-dropdowns';
import { DatePickerComponent, FocusEventArgs } from '@syncfusion/ej2-angular-calendars';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { detach, isNullOrUndefined, createElement, EventHandler, EmitType } from '@syncfusion/ej2-base';
import { _isNullOrUndefined } from "@syncfusion/ej2/pdf";

interface Countries {
    value: string;
    label: string;
}

@Component({
    selector: 'certification',
    templateUrl: './certificationcreate.component.html',
    providers: [PageService,
        SortService,
        FilterService,
        GroupService,
        CheckBoxSelectionService],
})
export class CertificationComponent implements AfterViewChecked {

    public onClose = (e) => {
        e.cancel = true;
    }

    @ViewChild('dateOfBirth', { static: false }) public dateOfBirth: DatePickerComponent;
    selectedDocumentType: any;
    selectedDocumentTypeId: any;

    onFocusDateOfBirth(args: FocusEventArgs): void {
        this.dateOfBirth.show();
    }

    @ViewChildren(Validator, { read: ElementRef }) validator: QueryList<ElementRef>

    countryList: Countries[];
    taxForm: FormGroup;
    errorCollection: any[];
    certificationId: string = "";
    participantName: string = "";
    taxFormData: any = [];
    selectedcountryOfResidence: Countries;
    selectedcountryOfIncorporation: Countries;
    selectedPrCntfResidence: Countries;
    selectedMailingCnt: Countries;
    selectedCountriesOfCitizenship: string[] =[];
    //showConfirmation: boolean = false;
    showPrivacy: boolean = false;
    showAppendixA: boolean = false;
    maxDOB: Date = null;
    minDOB: Date = null;
    calyearRange: string;
    certificationValue: number;
    //we need to create deep copy from the list for perfomnce
    countryOfResidenceList: any;
    countryOfIncorporationList: any;
    countryOfcitizenshipList: any;
    contactCountry: any;
    mailingCountry: any;
    public mode: string;
    public selectAllText: string;
    taxFormIntro: string;
    enableOwnerForm: boolean;
    ownerFormIntro: string;
    showW8W9ReplaceConfirmation: boolean;
    sharePrice: number;
    registeredShareholder: boolean = true;
    brokerName: string;
    errorCollectionFiles: any = [];
    errorCollectionFilesGroup2: any = [];
    attachmenApiURL: string;
    attachmenIDsApiURL: string;
    uploadedFiles: attachment[] = [];
    w8W9WebsiteUrl: string;
    refCode: string;
    isMailingAddressChecked: boolean = false;
    //targetElement: HTMLElement;
    public dropEle: HTMLElement;
    public dropEleFileInput2: HTMLElement;
    public dropEleFileInput3: HTMLElement;
    public parentElement: HTMLElement;
    public fileDetails: FileInfo;

    @ViewChild('fileInput1', { static: false }) fileInput1: UploaderComponent;
    @ViewChild('fileInput2', { static: false }) fileInput2: UploaderComponent;
    @ViewChild('fileInput3', { static: false }) fileInput3: UploaderComponent;
    @ViewChild('maskedInput', { static: false }) maskedInput!: MaskedTextBoxComponent;
    @ViewChild('grid') grid: GridComponent;

    constructor(private cdRef: ChangeDetectorRef, private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private certificationService: CertificationService, private title: Title) {

        this.title.setTitle('Identification and details of former Shareholder')
        this.maxDOB = new Date();
        let fullYear = this.maxDOB.getFullYear();
        let yearBack = fullYear - 120;
        this.minDOB = new Date(yearBack, this.maxDOB.getMonth(), this.maxDOB.getDate());

        this.calyearRange = this.minDOB.getFullYear() + ":" + this.maxDOB.getFullYear();
    }

    // Maps the appropriate column to fields property on Dropdowns and Multiselects
    public fields: Object = { text: 'label', value: 'value' };
    public countries: Countries[] = [
        { value: "USA", label: "United States of America (the)" },
        { value: "AFG", label: "Afghanistan" },
        { value: "ALA", label: "Åland Islands" },
        { value: "ALB", label: "Albania" },
        { value: "DZA", label: "Algeria" },
        { value: "ASM", label: "American Samoa" },
        { value: "AND", label: "Andorra" },
        { value: "AGO", label: "Angola" },
        { value: "AIA", label: "Anguilla" },
        { value: "ATA", label: "Antarctica" },
        { value: "ATG", label: "Antigua and Barbuda" },
        { value: "ARG", label: "Argentina" },
        { value: "ARM", label: "Armenia" },
        { value: "ABW", label: "Aruba" },
        { value: "AUS", label: "Australia" },
        { value: "AUT", label: "Austria" },
        { value: "AZE", label: "Azerbaijan" },
        { value: "BHS", label: "Bahamas (the)" },
        { value: "BHR", label: "Bahrain" },
        { value: "BGD", label: "Bangladesh" },
        { value: "BRB", label: "Barbados" },
        { value: "BLR", label: "Belarus" },
        { value: "BEL", label: "Belgium" },
        { value: "BLZ", label: "Belize" },
        { value: "BEN", label: "Benin" },
        { value: "BMU", label: "Bermuda" },
        { value: "BTN", label: "Bhutan" },
        { value: "BOL", label: "Bolivia (Plurinational State of)" },
        { value: "BES", label: "Bonaire, Sint Eustatius and Saba" },
        { value: "BIH", label: "Bosnia and Herzegovina" },
        { value: "BWA", label: "Botswana" },
        { value: "BVT", label: "Bouvet Island" },
        { value: "BRA", label: "Brazil" },
        { value: "IOT", label: "British Indian Ocean Territory (the)" },
        { value: "BRN", label: "Brunei Darussalam" },
        { value: "BGR", label: "Bulgaria" },
        { value: "BFA", label: "Burkina Faso" },
        { value: "BDI", label: "Burundi" },
        { value: "CPV", label: "Cabo Verde" },
        { value: "KHM", label: "Cambodia" },
        { value: "CMR", label: "Cameroon" },
        { value: "CAN", label: "Canada" },
        { value: "CYM", label: "Cayman Islands (the)" },
        { value: "CAF", label: "Central African Republic (the)" },
        { value: "TCD", label: "Chad" },
        { value: "CHL", label: "Chile" },
        { value: "CHN", label: "China" },
        { value: "CXR", label: "Christmas Island" },
        { value: "CCK", label: "Cocos (Keeling) Islands (the)" },
        { value: "COL", label: "Colombia" },
        { value: "COM", label: "Comoros (the)" },
        { value: "COD", label: "Congo (the Democratic Republic of the)" },
        { value: "COG", label: "Congo (the)" },
        { value: "COK", label: "Cook Islands (the)" },
        { value: "CRI", label: "Costa Rica" },
        { value: "CIV", label: "Côte d'Ivoire" },
        { value: "HRV", label: "Croatia" },
        { value: "CUB", label: "Cuba" },
        { value: "CUW", label: "Curaçao" },
        { value: "CYP", label: "Cyprus" },
        { value: "CZE", label: "Czechia" },
        { value: "DNK", label: "Denmark" },
        { value: "DJI", label: "Djibouti" },
        { value: "DMA", label: "Dominica" },
        { value: "DOM", label: "Dominican Republic (the)" },
        { value: "ECU", label: "Ecuador" },
        { value: "EGY", label: "Egypt" },
        { value: "SLV", label: "El Salvador" },
        { value: "GNQ", label: "Equatorial Guinea" },
        { value: "ERI", label: "Eritrea" },
        { value: "EST", label: "Estonia" },
        { value: "SWZ", label: "Eswatini" },
        { value: "ETH", label: "Ethiopia" },
        { value: "FLK", label: "Falkland Islands (the) [Malvinas]" },
        { value: "FRO", label: "Faroe Islands (the)" },
        { value: "FJI", label: "Fiji" },
        { value: "FIN", label: "Finland" },
        { value: "FRA", label: "France" },
        { value: "GUF", label: "French Guiana" },
        { value: "PYF", label: "French Polynesia" },
        { value: "ATF", label: "French Southern Territories (the)" },
        { value: "GAB", label: "Gabon" },
        { value: "GMB", label: "Gambia (the)" },
        { value: "GEO", label: "Georgia" },
        { value: "DEU", label: "Germany" },
        { value: "GHA", label: "Ghana" },
        { value: "GIB", label: "Gibraltar" },
        { value: "GRC", label: "Greece" },
        { value: "GRL", label: "Greenland" },
        { value: "GRD", label: "Grenada" },
        { value: "GLP", label: "Guadeloupe" },
        { value: "GUM", label: "Guam" },
        { value: "GTM", label: "Guatemala" },
        { value: "GGY", label: "Guernsey" },
        { value: "GIN", label: "Guinea" },
        { value: "GNB", label: "Guinea-Bissau" },
        { value: "GUY", label: "Guyana" },
        { value: "HTI", label: "Haiti" },
        { value: "HMD", label: "Heard Island and McDonald Islands" },
        { value: "VAT", label: "Holy See (the)" },
        { value: "HND", label: "Honduras" },
        { value: "HKG", label: "Hong Kong" },
        { value: "HUN", label: "Hungary" },
        { value: "ISL", label: "Iceland" },
        { value: "IND", label: "India" },
        { value: "IDN", label: "Indonesia" },
        { value: "IRN", label: "Iran (Islamic Republic of)" },
        { value: "IRQ", label: "Iraq" },
        { value: "IRL", label: "Ireland" },
        { value: "IMN", label: "Isle of Man" },
        { value: "ISR", label: "Israel" },
        { value: "ITA", label: "Italy" },
        { value: "JAM", label: "Jamaica" },
        { value: "JPN", label: "Japan" },
        { value: "JEY", label: "Jersey" },
        { value: "JOR", label: "Jordan" },
        { value: "KAZ", label: "Kazakhstan" },
        { value: "KEN", label: "Kenya" },
        { value: "KIR", label: "Kiribati" },
        { value: "PRK", label: "Korea (the Democratic People's Republic of)" },
        { value: "KOR", label: "Korea (the Republic of)" },
        { value: "KWT", label: "Kuwait" },
        { value: "KGZ", label: "Kyrgyzstan" },
        { value: "LAO", label: "Lao People's Democratic Republic (the)" },
        { value: "LVA", label: "Latvia" },
        { value: "LBN", label: "Lebanon" },
        { value: "LSO", label: "Lesotho" },
        { value: "LBR", label: "Liberia" },
        { value: "LBY", label: "Libya" },
        { value: "LIE", label: "Liechtenstein" },
        { value: "LTU", label: "Lithuania" },
        { value: "LUX", label: "Luxembourg" },
        { value: "MAC", label: "Macao" },
        { value: "MKD", label: "Macedonia (the former Yugoslav Republic of)" },
        { value: "MDG", label: "Madagascar" },
        { value: "MWI", label: "Malawi" },
        { value: "MYS", label: "Malaysia" },
        { value: "MDV", label: "Maldives" },
        { value: "MLI", label: "Mali" },
        { value: "MLT", label: "Malta" },
        { value: "MHL", label: "Marshall Islands (the)" },
        { value: "MTQ", label: "Martinique" },
        { value: "MRT", label: "Mauritania" },
        { value: "MUS", label: "Mauritius" },
        { value: "MYT", label: "Mayotte" },
        { value: "MEX", label: "Mexico" },
        { value: "FSM", label: "Micronesia (Federated States of)" },
        { value: "MDA", label: "Moldova (the Republic of)" },
        { value: "MCO", label: "Monaco" },
        { value: "MNG", label: "Mongolia" },
        { value: "MNE", label: "Montenegro" },
        { value: "MSR", label: "Montserrat" },
        { value: "MAR", label: "Morocco" },
        { value: "MOZ", label: "Mozambique" },
        { value: "MMR", label: "Myanmar" },
        { value: "NAM", label: "Namibia" },
        { value: "NRU", label: "Nauru" },
        { value: "NPL", label: "Nepal" },
        { value: "NLD", label: "Netherlands (the)" },
        { value: "NCL", label: "New Caledonia" },
        { value: "NZL", label: "New Zealand" },
        { value: "NIC", label: "Nicaragua" },
        { value: "NER", label: "Niger (the)" },
        { value: "NGA", label: "Nigeria" },
        { value: "NIU", label: "Niue" },
        { value: "NFK", label: "Norfolk Island" },
        { value: "MNP", label: "Northern Mariana Islands (the)" },
        { value: "NOR", label: "Norway" },
        { value: "OMN", label: "Oman" },
        { value: "PAK", label: "Pakistan" },
        { value: "PLW", label: "Palau" },
        { value: "PSE", label: "Palestine, State of" },
        { value: "PAN", label: "Panama" },
        { value: "PNG", label: "Papua New Guinea" },
        { value: "PRY", label: "Paraguay" },
        { value: "PER", label: "Peru" },
        { value: "PHL", label: "Philippines (the)" },
        { value: "PCN", label: "Pitcairn" },
        { value: "POL", label: "Poland" },
        { value: "PRT", label: "Portugal" },
        { value: "PRI", label: "Puerto Rico" },
        { value: "QAT", label: "Qatar" },
        { value: "REU", label: "Réunion" },
        { value: "ROU", label: "Romania" },
        { value: "RUS", label: "Russian Federation (the)" },
        { value: "RWA", label: "Rwanda" },
        { value: "BLM", label: "Saint Barthélemy" },
        { value: "SHN", label: "Saint Helena, Ascension and Tristan da Cunha" },
        { value: "KNA", label: "Saint Kitts and Nevis" },
        { value: "LCA", label: "Saint Lucia" },
        { value: "MAF", label: "Saint Martin (French part)" },
        { value: "SPM", label: "Saint Pierre and Miquelon" },
        { value: "VCT", label: "Saint Vincent and the Grenadines" },
        { value: "WSM", label: "Samoa" },
        { value: "SMR", label: "San Marino" },
        { value: "STP", label: "Sao Tome and Principe" },
        { value: "SAU", label: "Saudi Arabia" },
        { value: "SEN", label: "Senegal" },
        { value: "SRB", label: "Serbia" },
        { value: "SYC", label: "Seychelles" },
        { value: "SLE", label: "Sierra Leone" },
        { value: "SGP", label: "Singapore" },
        { value: "SXM", label: "Sint Maarten (Dutch part)" },
        { value: "SVK", label: "Slovakia" },
        { value: "SVN", label: "Slovenia" },
        { value: "SLB", label: "Solomon Islands" },
        { value: "SOM", label: "Somalia" },
        { value: "ZAF", label: "South Africa" },
        { value: "SGS", label: "South Georgia and the South Sandwich Islands" },
        { value: "SSD", label: "South Sudan" },
        { value: "ESP", label: "Spain" },
        { value: "LKA", label: "Sri Lanka" },
        { value: "SDN", label: "Sudan (the)" },
        { value: "SUR", label: "Surilabel" },
        { value: "SJM", label: "Svalbard and Jan Mayen" },
        { value: "SWE", label: "Sweden" },
        { value: "CHE", label: "Switzerland" },
        { value: "SYR", label: "Syrian Arab Republic" },
        { value: "TWN", label: "Taiwan (Province of China)" },
        { value: "TJK", label: "Tajikistan" },
        { value: "TZA", label: "Tanzania, United Republic of" },
        { value: "THA", label: "Thailand" },
        { value: "TLS", label: "Timor-Leste" },
        { value: "TGO", label: "Togo" },
        { value: "TKL", label: "Tokelau" },
        { value: "TON", label: "Tonga" },
        { value: "TTO", label: "Trinidad and Tobago" },
        { value: "TUN", label: "Tunisia" },
        { value: "TUR", label: "Turkey" },
        { value: "TKM", label: "Turkmenistan" },
        { value: "TCA", label: "Turks and Caicos Islands (the)" },
        { value: "TUV", label: "Tuvalu" },
        { value: "UGA", label: "Uganda" },
        { value: "UKR", label: "Ukraine" },
        { value: "ARE", label: "United Arab Emirates (the)" },
        { value: "GBR", label: "United Kingdom of Great Britain and Northern Ireland (the)" },
        { value: "UMI", label: "United States Minor Outlying Islands (the)" },
        { value: "URY", label: "Uruguay" },
        { value: "UZB", label: "Uzbekistan" },
        { value: "VUT", label: "Vanuatu" },
        { value: "VEN", label: "Venezuela (Bolivarian Republic of)" },
        { value: "VNM", label: "Viet Nam" },
        { value: "VGB", label: "Virgin Islands (British)" },
        { value: "VIR", label: "Virgin Islands (U.S.)" },
        { value: "WLF", label: "Wallis and Futuna" },
        { value: "ESH", label: "Western Sahara*" },
        { value: "YEM", label: "Yemen" },
        { value: "ZMB", label: "Zambia" },
        { value: "ZWE", label: "Zimbabwe" }
    ];
    public placeholderSelectCountry: string = 'Select country';

    ngAfterViewChecked() {
        this.dropEle = document.getElementById('dropArea');
        this.dropEleFileInput2 = document.getElementById('dropAreaFileInput2');
        this.dropEleFileInput3 = document.getElementById('dropAreaFileInput3');
        this.cdRef.detectChanges();

    }
    ngOnInit() {
        //loads the data from Route incase the user has come back from Review Page...
        this.taxFormData = this.route.snapshot.data['data'];
        this.brokerName = AppSettings.getParticipantName();
        this.mode = 'CheckBox';
        var tempcertificateid = AppSettings.getCertificationID();
        var pid = AppSettings.getParticipantID();
        let APIURL: string;
        this.pageSettings = { pageSize: 6 };
        this.dropEle = document.getElementById('dropArea');
        this.dropEleFileInput2 = document.getElementById('dropAreaFileInput2');
        this.dropEleFileInput3 = document.getElementById('dropAreaFileInput3');

        if (!tempcertificateid) {
            this.certificationService.initiateTempCertification({ identifier: pid }).subscribe((response: any) => {

                if (response.valid > 0) {

                    sessionStorage.setItem("Cid", response.tempCertificationId);
                    APIURL = `api/certification/uploadattachments?cid=${response.tempCertificationId}`;
                    this.attachmenApiURL = APIURL.toServerURL(true).toString();
                    this.attachmenIDsApiURL = APIURL.toServerURL(true).toString();

                }
            });
        } else {
            APIURL = `api/certification/uploadattachments?cid=${tempcertificateid}`;
            this.attachmenApiURL = APIURL.toServerURL(true).toString();
            this.attachmenIDsApiURL = APIURL.toServerURL(true).toString();
        }

        //init the reactive form..
        this.initTaxForm(this.taxFormData.certificationObject, this.taxFormData.taxFormConents);
        // this.initTaxForm(null);
        this.participantName = AppSettings.getParticipantName();

        this.refCode = AppSettings.getReferenceCode().toUpperCase();

        // Multiselect - set the type of mode for checkbox to visualized the checkbox added in li element.
        this.mode = 'CheckBox';
        // set the select all text to MultiSelect checkbox label.
        this.selectAllText = 'Select All';
        this.cdRef.detectChanges();

    }

    clickBrowse(e: MouseEvent, uploaderType: string): void {
        e.preventDefault(); // Prevent default anchor behavior

        // Determine the correct uploader's file select button
        let fileSelectWrap: HTMLElement | null;
        if (uploaderType === 'fileInput1') {
            fileSelectWrap = document.querySelector('#dropArea .e-file-select-wrap');
        }
        else if (uploaderType === 'fileInput2') {
            fileSelectWrap = document.querySelector('#dropAreaFileInput2 .e-file-select-wrap');
        }
        else if (uploaderType === 'fileInput3') {
            fileSelectWrap = document.querySelector('#dropAreaFileInput3 .e-file-select-wrap');
        }
        else {
            console.error('Invalid uploader type:', uploaderType);
            return;
        }

        const button = fileSelectWrap?.querySelector('button');
        if (button) {
            button.click();
        }
    }


    onUpload(event: any, IsIds: boolean) {
        var index: number = 0;
        //console.log(IsIds ? this.onDocumentSelectIds(null) : this.onDocumentSelect(null));

        let response = event.e.currentTarget?.response;
        let responseObject = JSON.parse(response);

        if (responseObject && responseObject.attachmentIds) {
            var fileData: attachment = {
                fileId: responseObject.attachmentIds[index],
                fileName: event.file.name,
                type: IsIds ? this.onDocumentSelectIds(null) : this.onDocumentSelect(null),
                size: event.file.size
            };
            index++;
            this.uploadedFiles.push(fileData);
            if (this.grid)
                this.grid.refresh();
        }

        this.errorCollectionFiles = [];
        this.errorCollectionFilesGroup2 = [];
        // Clear the UI after upload succeeds
        if (event.operation === 'upload') {
            // Clear all files
            if (this.fileInput1) {
                this.fileInput1.clearAll();
            }
            if (this.fileInput2) {
                this.fileInput2.clearAll();
            }
            if (this.fileInput3) {
                this.fileInput3.clearAll();
            }
        }
        //console.log(this.uploadedFiles);
    }

    private onFileSelect1(val: any) {
        this.prepareUploader('dropArea');

        this.fileDetails = val.filesData;
        //this.fileInput1.upload(val.filesData, true);

        //val.cancel = true;

    }

    private onFileSelect2(val: any) {
        this.prepareUploader('dropAreaFileInput2');
        this.fileDetails = val.filesData;
        //this.fileInput2.upload(val.filesData, true);
        //val.cancel = true;
    }

    private onFileSelect3(val: any) {
        this.prepareUploader('dropAreaFileInput3');
        this.fileDetails = val.filesData;
        //this.fileInput3.upload(val.filesData, true);
        //val.cancel = true;
    }


    private prepareUploader(dropAreaId: string): void {
        const dropArea = document.getElementById(dropAreaId);
        const existingList = dropArea?.querySelector('.upload-list-root');
        if (existingList) {
            dropArea.removeChild(existingList);
        }
        this.parentElement = createElement('div', { className: 'upload-list-root' });
        this.parentElement.appendChild(createElement('ul', { className: 'ul-element' }));
        dropArea.appendChild(this.parentElement);
    }


    onErrorUpload(event: any, url: string) {
        const xhr = event?.e?.currentTarget;

        if (xhr?.response) {
            const file = JSON.parse(xhr.response);
            var errorMessage = file[0].fileName;
            var fileType = file[0].fileType;

            //const fileType = !isNullOrUndefined(url) ? url.split('=')[1] : "";
            switch (fileType) {
                case 'W9':
                    this.errorCollectionFilesGroup2 = { fileName: [errorMessage] };
                    break;
                case 'W8':
                    this.errorCollectionFilesGroup2 = { fileName: [errorMessage] };
                    break;
                case 'Passport':
                    this.errorCollectionFilesGroup2 = { fileName: [errorMessage] };
                    break;
                case 'Residency':
                    this.errorCollectionFiles = { fileName: [errorMessage] };
                    break;
                case 'Tax Certificate':
                    this.errorCollectionFiles = { fileName: [errorMessage] };
                    break;
                default:
                    this.errorCollectionFiles = { fileName: [errorMessage] };
                    this.errorCollectionFilesGroup2 = { fileName: [errorMessage] };
                    break;
            }
        }
    }

    getSizeInMB(size: number): string {
        return (size / 1000000).toFixed(2);  // Converts to MB and formats to 2 decimal places
    }

    public getFileType(fileTypeInput: string): string {
        let fileType: string;

        switch (fileTypeInput) {
            case '1':
                fileType = 'Drivers-License';
                break;
            case '3':
                fileType = 'W9';
                break;
            case '4':
                fileType = 'W8';
                break;
            case '5':
                fileType = 'Passport';
                break;
            case '6':
                fileType = 'Residency';
                break;
            case '7':
                fileType = 'Tax Certificate';
                break;
            default:
                fileType = '';
                break;
        }

        return fileType;
    }



    removeFile(fileid: any) {

        this.certificationService.removeTempAttachment({ identifier: fileid }).subscribe((response: any) => {

            if (response.valid > 0) {
                var index = this.uploadedFiles.findIndex(file => file.fileId == fileid);
                this.uploadedFiles.splice(index, 1);

                if (this.grid)
                    this.grid.refresh();
            }
        });
    }

    initTaxForm(certificationObject: any, taxFormConents: any) {
        debugger;
        this.taxForm = this.fb.group({
            'privacyAuthorization': new FormControl(certificationObject == null || !certificationObject.brokerDetails ? null : (certificationObject.brokerDetails.privacyAuthorization == 'Yes' ? true : false)),
            'accountNumber': new FormControl(certificationObject == null || !certificationObject.brokerDetails ? '' : certificationObject.brokerDetails.accountNumber),

            'shareholderName': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.name),
            'shareholderType': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.typeId),
            'otherType': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.otherType),
            'havePassport': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.havePassport == 'Yes' ? '1' : '0'),
            'numberOfStockShares': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.rsuOptionShares),
            'countryOfResidence': new FormControl(null),
            'countryOfIncorporation': new FormControl(null),
            'documentType': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.documentType),
            'documentTypeIds': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.documentTypeIds),

            'registrationNumber': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.corporationNumber),
            'shareholderDateOfBirth': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.dateofBirth),
            'countriesOfCitizenship': new FormControl(null),
            'taxpayerTinOrSSN': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.taxIdentificationNumber),
            'taxpayerTinOrSSNUS': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.taxIdentificationNumber),
            'contactName': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.name),
            'contactCapacity': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.capacity),
            'contactEmail': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.email),
            'contactTelephoneNumber': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.telephone),
            'contactPermanentAddress1': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.streetAddress1),
            'contactPermanentAddress2': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.streetAddress2),
            'contactPermanentCity': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.streetCity),
            'contactPermanentState': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.streetState),
            'contactPermanentZipCode': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.streetPostcode),
            'contactPermanentCountryOfResidence': new FormControl(null),
            'isMailAddressSame': new FormControl(certificationObject == null || !certificationObject.contact ? null : (certificationObject.contact.isMalingAddressDifferent == 'Yes' ? true : false)),
            'contactMailingAddress1': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.mailingAddress1),
            'contactMailingAddress2': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.mailingAddress2),
            'contactMailingCity': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.mailingCity),
            'contactMailingState': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.mailingState),
            'contactMailingZipCode': new FormControl(certificationObject == null || !certificationObject.contact ? '' : certificationObject.contact.mailingPostcode),
            'contactMailingCountryOfResidence': new FormControl(null),

            'holdingType': new FormControl(certificationObject == null || !certificationObject.shareOwnership ? '2' : certificationObject.shareOwnership.holdingType),
            'shareBrokerName': new FormControl(certificationObject == null || !certificationObject.shareOwnership ? '' : certificationObject.shareOwnership.shareBrokerName),
            'lessThen5percShares': new FormControl(certificationObject == null || !certificationObject.shareOwnership ? null : (certificationObject.shareOwnership.lessThan5PercentShares == 'Yes' ? true : false)),
            'numberOfShares': new FormControl(certificationObject == null || !certificationObject.shareOwnership ? '' : certificationObject.shareOwnership.numberOfShares),
            'israeliCitizen': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.israeliCitizen),
            'israeliCitizenIdNumber': new FormControl(certificationObject == null || !certificationObject.identity ? '' : certificationObject.identity.israeliCitizenIdNumber),
        });

        this.taxForm.controls['havePassport'].valueChanges.subscribe(data => this.onPassportChange(data));
        this.taxForm.controls['shareholderType'].valueChanges.subscribe(data => this.onShareholderTypeChange(data));

        //set the selected Values in DropDowns...[if in edit mode..]
        if (certificationObject != null) {

            if (certificationObject.identity && certificationObject.identity.residencyCountry != "")
                this.selectedcountryOfResidence = certificationObject.identity.residencyCountry;
            if (certificationObject.identity && certificationObject.identity.corporationCountry != "")
                this.selectedcountryOfIncorporation = certificationObject.identity.corporationCountry;
            if (certificationObject.contact && certificationObject.contact.streetCountry != "")
                this.selectedPrCntfResidence = certificationObject.contact.streetCountry;
            if (certificationObject.contact && certificationObject.contact.mailingCountry != "")
                this.selectedMailingCnt = certificationObject.contact.mailingCountry;
            if (certificationObject.identity && certificationObject.identity.citizenshipCountries != "")
                this.setCountryOfCitizenshipSelected(certificationObject.identity.citizenshipCountries);

            if (certificationObject.identity && certificationObject.identity.typeId != '')
                this.taxFormControls['shareholderType'].setValue(certificationObject.identity.typeId);

            if (certificationObject.identity && certificationObject.identity.israeliCitizen != '')
                this.taxFormControls['israeliCitizen'].setValue(certificationObject.identity.israeliCitizen);
        }

        if (certificationObject != null && certificationObject.fileAttachments != null) {
            this.uploadedFiles = certificationObject.fileAttachments;
        } else {
            this.uploadedFiles = [];
        }

        if (taxFormConents != null) {
            this.taxFormIntro = taxFormConents.taxFormIntro;
            this.enableOwnerForm = taxFormConents.enableOwnerForm;
            this.ownerFormIntro = taxFormConents.ownerFormIntro;
            this.sharePrice = taxFormConents.sharePrice;
            this.registeredShareholder = taxFormConents.registeredShareholder !== undefined ? taxFormConents.registeredShareholder : true;
        }

        if (certificationObject?.identity?.documentType != "")
            this.selectedDocumentType = certificationObject?.identity?.documentType;
        if (certificationObject?.identity?.documentTypeIds != "")
            this.selectedDocumentTypeId = certificationObject?.identity?.documentTypeIds;

        this.onDocumentSelect(null);
        this.onDocumentSelectIds(null);
        this.onSharesCountChange();

    }

    onDocumentSelect(event: any): string {
        let fileType: string;
        if (event != null) {
            fileType = this.getFileType(event.value);
        }
        else {
            if (this.selectedDocumentType != "") {
                fileType = this.getFileType(this.selectedDocumentType);
            }
            else
                fileType = this.getFileType(this.taxFormControls['documentType'].value);
        }

        this.attachmenApiURL = `${this.attachmenApiURL}&type=${fileType}`;
        var uploadUrl = this.attachmenApiURL.substr(0, this.attachmenApiURL.indexOf('&type='));
        this.attachmenApiURL = `${uploadUrl}&type=${fileType}`;

        return fileType;
    }

    onDocumentSelectIds(event: any): string {
        let fileType: string;
        if (event != null) {
            fileType = this.getFileType(event.value);
        }
        else {
            if (this.selectedDocumentTypeId != "") {
                fileType = this.getFileType(this.selectedDocumentTypeId);
            }
            else
                fileType = this.getFileType(this.taxFormControls['documentTypeIds'].value);
        }

        this.attachmenIDsApiURL = `${this.attachmenIDsApiURL}&type=${fileType}`;
        var uploadUrl = this.attachmenIDsApiURL.substr(0, this.attachmenIDsApiURL.indexOf('&type='));
        this.attachmenIDsApiURL = `${uploadUrl}&type=${fileType}`;

        return fileType;
    }

    public pageSettings?: PageSettingsModel;
    get taxFormControls() {
        return this.taxForm.controls;
    }

    getFormattedSSN() {
        if (this.maskedInput) {
            const formattedValue = this.maskedInput.getMaskedValue();
            return formattedValue;
        }
        return '';
    }

    onCountriesChange(event: any) {
        this.taxForm.get('countriesOfCitizenship').setValue(event.value);
    }

    setCountryOfCitizenshipSelected(listOfCountries: string) {
        if (listOfCountries) {
            const citizenshipCountries = listOfCountries.split(',');
            this.selectedCountriesOfCitizenship = citizenshipCountries;
            this.taxForm.get('countriesOfCitizenship').setValue(this.selectedCountriesOfCitizenship);
        } else {
            this.selectedCountriesOfCitizenship = [];
        }
    }

    getCommaSeparatedIds(arrayOfElements: any): string {
        let values = "";
        if (arrayOfElements != null) {
            values = arrayOfElements.map((e: any) => (typeof e === "object" && e.value ? e.value : e))
                .join(",");
        }
        return values;
    }


    getCountryNameByCode(code: string): string {
        const country = this.countries.find((c: any) => c.value === code);
        return country ? country.label : '';
    }
    countryOfResidenceChange() {
        if (this.taxFormControls['countryOfResidence'].value != null && this.taxFormControls['countryOfResidence'].value == 'USA') {
            this.taxFormControls['taxpayerTinOrSSN'].setValue('');
        }
        else {
            this.taxFormControls['taxpayerTinOrSSNUS'].setValue('');
        }

        this.setDefaultDocument();
    }

    submitDetails() {
        this.clearUIErrors();
        let DOb = this.taxFormControls['shareholderDateOfBirth'].value;
        let dateToSave = "";
        if (DOb != '') {

            let d = new Date(DOb);
            dateToSave = d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
        }

        let taxFormModel: taxFormModel = {

            participantId: AppSettings.getParticipantID(),
            certificationId: AppSettings.getCertificationID(),

            brokerName: this.brokerName,
            privacyAuthorization: this.taxFormControls['privacyAuthorization'].value == null ? false : this.taxFormControls['privacyAuthorization'].value,
            accountNumber: this.taxFormControls['accountNumber'].value,

            shareholderName: this.taxFormControls['shareholderName'].value,
            shareholderType: this.taxFormControls['shareholderType'].value,
            otherType: this.taxFormControls['otherType'].value,
            countryOfResidence: this.taxFormControls['countryOfResidence'].value == null ? "" : this.taxFormControls['countryOfResidence'].value,
            countryOfIncorporation: this.taxFormControls['countryOfIncorporation'].value == null ? "" : this.taxFormControls['countryOfIncorporation'].value,
            registrationNumber: this.taxFormControls['registrationNumber'].value,
            shareholderDateOfBirth: dateToSave,
            countriesOfCitizenship: this.taxFormControls['countriesOfCitizenship'].value == null ? "" : this.getCommaSeparatedIds(this.taxFormControls["countriesOfCitizenship"].value),
            taxpayerTinOrSSN: this.taxFormControls['taxpayerTinOrSSN'].value,
            taxpayerTinOrSSNUS: this.getFormattedSSN(), // this.taxFormControls['taxpayerTinOrSSNUS'].value,
            contactName: this.taxFormControls['contactName'].value,
            contactEmail: this.taxFormControls['contactEmail'].value,
            contactCapacity: this.taxFormControls['contactCapacity'].value,
            contactTelephoneNumber: this.taxFormControls['contactTelephoneNumber'].value,
            contactPermanentAddress1: this.taxFormControls['contactPermanentAddress1'].value,
            contactPermanentAddress2: this.taxFormControls['contactPermanentAddress2'].value,
            contactPermanentCity: this.taxFormControls['contactPermanentCity'].value,
            contactPermanentState: this.taxFormControls['contactPermanentState'].value,
            contactPermanentZipCode: this.taxFormControls['contactPermanentZipCode'].value,
            contactPermanentCountryOfResidence: this.taxFormControls['contactPermanentCountryOfResidence'].value == null ? "" : this.taxFormControls['contactPermanentCountryOfResidence'].value,
            isMailAddressSame: this.taxFormControls['isMailAddressSame'].value == null ? false : this.taxFormControls['isMailAddressSame'].value,
            contactMailingAddress1: this.taxFormControls['contactMailingAddress1'].value,
            contactMailingAddress2: this.taxFormControls['contactMailingAddress2'].value,
            contactMailingCity: this.taxFormControls['contactMailingCity'].value,
            contactMailingState: this.taxFormControls['contactMailingState'].value,
            contactMailingZipCode: this.taxFormControls['contactMailingZipCode'].value,
            contactMailingCountryOfResidence: this.taxFormControls['contactMailingCountryOfResidence'].value == null ? "" : this.taxFormControls['contactMailingCountryOfResidence'].value,
            holdingType: this.taxFormControls['holdingType'].value ?? "",
            shareBrokerName: this.taxFormControls['shareBrokerName'].value,
            lessThen5percShares: this.taxFormControls['lessThen5percShares'].value == null ? false : this.taxFormControls['lessThen5percShares'].value,
            lessThen5percVoting: 'false',
            lessThen5percProfit: 'false',
            noRightsToAppointDirector: 'false',
            numberOfShares: this.taxFormControls['numberOfShares'].value,
            havePassport: this.taxFormControls['havePassport'].value,
            shareWorthLess300k: (this.certificationValue > 300000 ? '0' : '1'),
            shareWorthMore500k: (this.certificationValue > 500000.00 ? '1' : '0'),
            numberOfStockShares: this.taxFormControls['numberOfStockShares'].value,
            certificationValue: this.certificationValue.toString(),
            documentType: this.taxFormControls["documentType"].value,
            documentTypeIds: this.taxFormControls["documentTypeIds"].value,
            uploadedFiles: this.uploadedFiles,
            israeliCitizen: this.taxFormControls['israeliCitizen'].value,
            israeliCitizenIdNumber: this.taxFormControls['israeliCitizenIdNumber'].value

        };

        //console.log('----');
        //console.log(taxFormModel);
        //console.log('----');


        //pass the data to service;
        this.certificationService.submitTaxForm(taxFormModel)
            .subscribe((response: any) => {
                if (response.valid > 0) {
                    //Save the TempCert ID in localstorage and move to Review Page....
                    sessionStorage.setItem("Cid", response.tempCid);
                    this.navigateToNext();
                }
            },
                (error) => {
                    this.errorCollection = error;
                    let scrolltoError;
                    let validationControls = this.validator.toArray();
                    for (let obj of validationControls) {
                        let id = obj.nativeElement.id;
                        if (error[id] != null) {
                            scrolltoError = obj.nativeElement;
                            break;
                        }
                    }
                    scrolltoError.parentNode.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                    //console.log(validationControls);
                }

            );
    }


    navigateToNext() {
        this.router.navigate(['review/']);

    }

    navigateToReview() {
        this.showW8W9ReplaceConfirmation = false;
        this.router.navigate(['review/']);
    }

    clearUIErrors() {

        this.errorCollection = [];
    }

    confirmYes() {

        AppSettings.removereferenceNumber();
        AppSettings.removeTempCertificationId();
        this.router.navigate(['welcome/']);
    }

    showDialog() {
        this.showPrivacy = true;
    }

    onSharesCountChange() {
        var shareValue = this.taxFormControls['numberOfShares'].value * this.sharePrice;

        this.certificationValue = shareValue;
        this.setDefaultDocument();
    }


    onPassportChange(data) {
        this.setDefaultDocument();
        return true;
    }


    onShareholderTypeChange(data) {
        // Reset Countries of Citizenship when shareholderType is not individual (not '2')
        if (data !== '2') {
            this.taxForm.get('countriesOfCitizenship')?.setValue(null);
            this.selectedCountriesOfCitizenship = [];
        }
        
        this.setDefaultDocument();
        return true;
    }

    setDefaultDocument() {
        this.taxFormControls['documentType'].setValue('');
        this.taxFormControls['documentTypeIds'].setValue('');

        this.onDocumentSelect(null);
        this.onDocumentSelectIds(null);
    }

    onSharesFocusOut() {

    }

    sharesWorthSelectionChange() {

    }

    validateFile($event: any, maxFileSize: number): void {
        this.errorCollectionFiles = [];
        if ($event.files[0].type != "image/jpeg" && $event.files[0].type != "application/pdf" && $event.files[0].type != "image/png") {
            //this.fileInput.files = [];
            this.errorCollectionFiles = { fileName: ["Only PDF and Image files types allowed."] };
        }

        if ($event.files[0].size > maxFileSize) {
            //this.fileInput.files = [];
            this.errorCollectionFiles = { fileName: ["File size more than 5MB is not allowed."] };
        }
    }

    checkCitizenContainsIsrael() {
        var selectedcitizenshipCountries = this.getCommaSeparatedIds(this.taxFormControls["countriesOfCitizenship"].value);
        var citizenshipCountries = selectedcitizenshipCountries.split(',').filter(country => country.trim() !== '');

        // Return true only if ISR is present AND it's the only citizenship
        return citizenshipCountries.indexOf("ISR") != -1 && citizenshipCountries.length === 1;
    }


    checkCitizenOfIsrael() {
        var selectedcitizenshipCountries = this.getCommaSeparatedIds(this.taxFormControls["countriesOfCitizenship"].value);
        var citizenshipCountries = selectedcitizenshipCountries.split(',').filter(country => country.trim() !== '');

        // Return true only if ISR is present AND it's the only citizenship
        return citizenshipCountries.indexOf("ISR") != -1;
    }

    checkIsraelResident() {
        if (this.taxFormControls['countryOfResidence'].value != null) {
            return this.taxFormControls['countryOfResidence'].value == 'ISR';
        }
        return false;
    }

    checkIsraelResidentAndCitizen() {
        var selectedcitizenshipCountries = this.getCommaSeparatedIds(this.taxFormControls["countriesOfCitizenship"].value);
        var citizenshipCountries = selectedcitizenshipCountries.split(',');
        if (this.taxFormControls['countryOfResidence'].value != null) {
            return citizenshipCountries.indexOf("ISR") != -1 && this.taxFormControls['countryOfResidence'].value == 'ISR';
        }
        return false;
    }

    /* Modal Dialogs --------------------------------------------------------------------------------------------------------------- */

    // The Dialog shows within the target element.
    public targetElement: HTMLElement;

    // Sets the Dialog to hidden on page load
    public visible: Boolean = false;

    @ViewChild('cancelConfirmationDialog', { static: false }) public cancelConfirmationDialog: DialogComponent;

    // Call the show method to open the Dialog
    public showCancelConfirmationDialog = function (event: any): void {
        this.cancelConfirmationDialog.show();
    }

    // Hide the Dialog when click the footer button.
    public hideCancelConfirmationDialog: EmitType<object> = () => {
        this.cancelConfirmationDialog.hide();
    }

    // This is the animation on focus/blur on textboxes
    public focusIn(target: HTMLElement): void {
        target.parentElement.classList.add('e-input-focus');
    }

    public focusOut(target: HTMLElement): void {
        target.parentElement.classList.remove('e-input-focus');
    }

    public onMouseDown(target: HTMLElement): void {
        target.classList.add('e-input-btn-ripple');
    }

    public onMouseUp(target: HTMLElement): void {
        let ele: HTMLElement = target;
        setTimeout(
            () => { ele.classList.remove('e-input-btn-ripple'); },
            500);
    }
}
